<template>
  <div class="voiceButton">
    <div class="btn border" :class="side? 'right':'left'" @click="playVO">
      <div class="btn-bar">
        <div class="pill eye" @mouseover="hoverEye(1)" @mouseout="hoverEye(0)" ><font-awesome-icon :icon="['fab','hubspot']"></font-awesome-icon></div>
        <div class="pill textarea">
          <p class="filename" v-show="isFilenameShown()">{{srcfilename}}</p>
          <p class="text">
             {{voiceline}}</p>
        </div>
        <div class="pill download" @click="downloadSoundFile" ><font-awesome-icon icon="cloud-download-alt"></font-awesome-icon></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:['vo', //object
  'lang', //"cn", "en"
  'side',// 0 = left, 1 = right;
  'showname'], 
  data(){
    return {
      languageEye: 0,
    }
  },
  computed:{
    language () {
      if(this.languageEye^this.lang=="cn"){return "cn"}else{return "en"}
    },
    srcfilename(){
      return this.vo.filename+"."+this.vo.ext;
    },
    voiceline(){
      let textlang = "text"+ this.language.toUpperCase();
      let linetext = this.vo[textlang];
      linetext = linetext ? linetext : "";
      return linetext;
    },
    playURL () {
      let path = "play"+this.language.toUpperCase();
      return this.vo[path];
    }
  },
  methods:{
    playVO(){
      this.$emit('play',this.playURL);
    },
    downloadSoundFile(event){
      if(window.adblock===undefined){
        event.stopPropagation();
      }
      this.$emit('download');
    },
    isFilenameShown(){
      let result = false;
      //如果没有文本内容则始终显示文件名
      let textlang = "text" + this.lang.toUpperCase();
      if (this.vo[textlang]){result = false}else {result = true};
      //合并 controlBar 选项
      result = result ||this.showname;
      //return
      return result;
    },
    hoverEye(status){
      this.languageEye = status;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@leftcolor:#1b9af7;
@rightcolor:#ff4351;
.voiceButton{
  cursor: pointer;
  min-width: 180px;
  transition: 0.5s;
  overflow: hidden;
  width: 100%;
  &:hover{
    z-index: 999;
    box-shadow: 2px 0px 4px rgba(0,0,0, 0.15),
    0px 2px 4px rgba(0,0,0, 0.15),
    -2px 0px 4px rgba(0,0,0, 0.15),
    0px -2px 4px rgba(0,0,0, 0.15);
    transition: 0.5s;
  }
}
.border{
  widows: 100%;
}
.btn-bar{
  display:flex;
  position: relative;
  widows: 100%;
  padding: 2px;
  min-height: 24px;
  background: rgba(255, 255, 255, 0.9);
  &:hover{
    background: #fff;
  }
  .pill{
    display: flex;
    flex-direction: column;
    justify-content:center;
    padding: 0 6px;
  }
  .pill.download{font-size:13px;}
  .pill.eye{font-size:16px;}
  .pill.textarea{
    flex-grow: 1;
    font-size: 14px;
    padding: 0px 2px;
    .filename,.text{
      display: block;
      text-align: left;
    }
    .filename{
      font-size: 12px;
      font-weight: bold;
      transform: scale(0.95);
      transform-origin: 0 0;
    }
  }
}

.left{
  .btn-bar{
    .pill{
      color:@leftcolor;
    }
  }
}
.right{
  .pill{
    color:@rightcolor;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/soundPlay.vue